module.exports = __webpack_public_path__ + "static/logo-cf3444e27ea70e81bb1f9c1968483223.png";